// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 745 ? "posthog" : chunkId) + "." + {"236":"f59e8e5a","266":"004d671b","584":"e1e9b57e","595":"e984163a","602":"92ae4e78","693":"0a76ebf1","745":"ab7d0a47","868":"dfbce82d"}[chunkId] + ".chunk.js";
};